/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon-truck[_ngcontent-%COMP%]{width:38px;height:24px}.infoWarningBox[_ngcontent-%COMP%]{-ms-flex-align:center;align-items:center}.infoWarningBoxIcon[_ngcontent-%COMP%]{margin-top:0!important}.pl15[_ngcontent-%COMP%]{padding-left:15px}"];
export { styles as styles };
